




























import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Confirm from "@/shared/components/confirm.vue";
import { ConsultoresService } from "@/services/consultores.service";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
  },
})
export default class LimpezaConsultor extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  manterClientes: boolean | null = true;
  msgConsultor: string | null = "";
  showDados?: boolean = false;

  async LimpezaBase() {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Limpar base do cliente`;
    const text = `ESTA AÇÃO NÃO TEM RETORNO!!! Tem certeza que deseja EXCLUIR os dados do cliente selecionado?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      const msg = await ConsultoresService.LimpezaBase(
        this.idConsultor,
        this.manterClientes
      ).finally(this.stopLoader);
      if (msg) {
        this.msgConsultor = "Dados apagados com sucesso!";
        this.showDados = true;
        setTimeout(this.fechaAlertaDados, 5000);
      }
    }
  }
  fechaAlertaDados() {
    this.showDados = false;
  }
}
